import request from '@/axios'

export function smsTemplateShow (customer_id, template_id) {
  return request({
    url: `/communication/template/show/${customer_id}/${template_id}/SMS`,
    method: 'GET'
  })
}

export function smsTemplateList (sorting_obj, table_name, payload, customer_id, page, limit) {
  return request({
    url: `/communication/template/list/${customer_id}/SMS?attribute=${sorting_obj.attribute}&direction=${sorting_obj.direction}&field_type=${sorting_obj.field_type}&table_name=${table_name}&page=${page}&limit=${limit}`,
    method: 'POST',
    data: payload
  })
}

export function smsDynamicFieldList (customer_id) {
  return request({
    url: `/emailDynamicFields/list/${customer_id}`,
    method: 'GET'
  })
}

export function smsTypeList () {
  return request({
    url: '/emailType/list',
    method: 'GET'
  })
}

export function smsTemplateCreate (customer_id, query) {
  return request({
    url: `/communication/template/create/${customer_id}/SMS`,
    method: 'POST',
    data: query
  })
}

export function smsTemplateEdit (customer_id, template_id, query) {
  return request({
    url: `/communication/template/edit/${customer_id}/SMS/${template_id}`,
    method: 'POST',
    data: query
  })
}


export function smsMapFields (customer_id, query) {
  return request({
    url: `/communication/map/fields/${customer_id}/SMS`,
    method: 'POST',
    data: query
  })
}

export function smsTemplateDelete (customer_id, query) {
  return request({
    url: `/communication/template/delete/${customer_id}/SMS`,
    method: 'POST',
    data: query
  })
}


export function smsLog (sorting_obj, table_name, payload, customer_id, page = 1, limit) {
  let url = `/communication/sms/log/${customer_id}?table_name=${table_name}&page=${page}&limit=${limit}`
  if (Object.entries(sorting_obj).length > 0) {
    url = `communication/sms/log/${customer_id}?attribute=${sorting_obj.attribute}&direction=${sorting_obj.direction}&field_type=${sorting_obj.field_type}&table_name=${table_name}&page=${page}&limit=${limit}`
  }
  return request({
    url,
    method: 'POST',
    data: payload
  })
}

